import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-iws-nb-contact-tile-group",
    styleUrl: "nb-contact-tile-group.scss",
    shadow: true,
})
export class NbContactTileGroup {
    /** headline text */
    @Prop() headline?: string;
    /** subheadline text */
    @Prop() subheadline?: string;

    render() {
        return (
            <Host>
                {this.headline && <h2 class="headline">{this.headline}</h2>}
                {this.subheadline && (
                    <h3 class="subheadline">{this.subheadline}</h3>
                )}
                <div class="tile-group">
                    <slot />
                </div>
            </Host>
        );
    }
}
